const features = [
  {
    icon: "ri-shield-flash-line",
    title: "Real-Time Threat Protection",
    desc: "Our VPN continuously monitors traffic to block malicious sites and prevent unauthorized data access before it reaches your device.",
    accent: "emerald",
  },
  {
    icon: "ri-fingerprint-line",
    title: "Privacy by Design",
    desc: "We maintain a strict zero-log policy. No browsing data, connection timestamps, or personal activity is ever stored or shared.",
    accent: "emerald",
  },
  {
    icon: "ri-rocket-2-line",
    title: "Instant Performance Boost",
    desc: "Our Cleaner app identifies and eliminates performance bottlenecks in seconds, delivering a noticeably faster iOS experience.",
    accent: "sky",
  },
  {
    icon: "ri-smartphone-line",
    title: "Seamless iOS Integration",
    desc: "Built natively for iOS, our apps integrate deeply with Apple&apos;s ecosystem for smooth, battery-efficient, and reliable performance.",
    accent: "sky",
  },
  {
    icon: "ri-refresh-line",
    title: "Automatic Smart Cleaning",
    desc: "Schedule regular maintenance with intelligent automation that keeps your device optimized without any manual effort.",
    accent: "sky",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "24/7 Dedicated Support",
    desc: "Our support team is always ready to assist. Get quick, helpful answers to any questions about our applications.",
    accent: "emerald",
  },
];

const accentMap: Record<string, { bg: string; icon: string; badge: string }> = {
  emerald: {
    bg: "bg-emerald-50",
    icon: "text-emerald-600",
    badge: "bg-emerald-100 text-emerald-700",
  },
  sky: {
    bg: "bg-sky-50",
    icon: "text-sky-600",
    badge: "bg-sky-100 text-sky-700",
  },
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-4">
            // Key Features
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
            Designed with Precision,
            <br />
            Engineered for Performance
          </h2>
          <p className="text-gray-500 text-lg mt-5 max-w-xl mx-auto">
            Every feature is carefully built to deliver a best-in-class iOS experience across security and optimization.
          </p>
        </div>

        {/* Feature image showcase */}
        <div className="rounded-3xl overflow-hidden mb-16 w-full" style={{ height: "380px" }}>
          <img
            src="https://public.readdy.ai/ai/img_res/fa38e555cd5fcab4f3034f50bd7d6f99.jpg"
            alt="CERTROM SRL iOS apps features showcase"
            className="w-full h-full object-cover object-top"
          />
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => {
            const ac = accentMap[f.accent];
            return (
              <div
                key={f.title}
                className="bg-white rounded-2xl p-7 border border-gray-100 group hover:border-gray-200 transition-all duration-200"
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${ac.bg} mb-5`}>
                  <i className={`${f.icon} text-xl ${ac.icon}`} />
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-3">{f.title}</h3>
                <p
                  className="text-gray-500 text-sm leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: f.desc }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
